import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { ApiRoutes } from "./Routes";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b;
    setLoading(true);
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.Sophos.CHECK_CREDENTIALS), {
      sophos_client_id: ((_a = formData == null ? void 0 : formData.sophosClientId) == null ? void 0 : _a.value) || "",
      sophos_client_secret: ((_b = formData == null ? void 0 : formData.sophosClientSecret) == null ? void 0 : _b.value) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Sophos using provided configuration."
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Sophos using provided configuration."
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["sophosName", "sophosClientId", "sophosClientSecret"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosName",
        type: "text",
        fieldData: formData.sophosName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosClientId",
        type: "text",
        onChange,
        fieldData: formData.sophosClientId,
        label: "Sophos Client ID",
        help: "client ID for sophos account.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "sophosClientSecret",
        type: "password",
        onChange,
        fieldData: formData.sophosSecret,
        label: "Sophos Client Secret",
        help: "client secret for sophos account.",
        required: true
      }
    )
  );
};
export default StepAuthorize;
